import {scrolEvents} from './default';
import {index} from './index';
import {vues} from './vues';

document.addEventListener('DOMContentLoaded', function() {
	let scene = [];
	let controller;
    controller =  new ScrollMagic.Controller();
	vues();
	scrolEvents(controller , scene);
    index();
    
});